import { Component, Input, ElementRef, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import moment from 'moment';
import isNull from 'lodash-es/isNull';

import { InlineFieldInterfaceComponent } from '../inline-field-interface.component';
import { PartialFormField } from '../../form-fields/form-field.types';

@Component({
  templateUrl: './datetime-inline-field.component.html',
})
export class DateTimeInlineFieldComponent implements InlineFieldInterfaceComponent, OnInit {
  @ViewChild('dtPicker1') dtPicker: ElementRef;

  @Input() model: any;
  @Input() fieldDef: any;
  @Input() data: any;
  @Input() excludeLabels: boolean = false;
  @Input() readonly: boolean = false;
  @Input() showEmptyHolder: boolean = false;
  @Output() update: EventEmitter<PartialFormField> = new EventEmitter();

  public value: string = '';
  public editing: boolean = false;
  private _originalValue;
  public emptyCellOverlay;

  ngOnInit() {
    this.value = this.fieldDef.meta?.value_hidden ? 'REDACTED' : this.model[this.fieldDef.name];
    this.emptyCellOverlay = this.showEmptyHolder && isNull(this.value);
    this._originalValue = this.value;
    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this.readonly = this.fieldDef.meta.readonly;
    }
    this.formatDate();
  }

  edit() {
    if (!this.editing && !this.readonly) {
      this.editing = true;
    }
  }

  hideEdit() {
    this.editing = false;
  }

  formatDate() {
    if (this.value && this.value !== 'REDACTED') {
      const momentDate = moment(this.value);
      this.value = momentDate.format('YYYY-MM-DD');
    }
  }

  onBlur($event?: Event) {
    this.hideEdit();

    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  updateModel() {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  onDateChange(type: string, event: MatDatepickerInputEvent<Date>) {
    if (!this.readonly) {
      const momentDate = moment(event.value).add(12, 'hours');
      this.value = momentDate.format('YYYY-MM-DD HH:mm:ss');
      this.emptyCellOverlay = this.showEmptyHolder && isNull(this.value);
      this.onBlur();
    }
  }
}
